namespace Cfnc {
    "use strict";

    interface IActivitiesInterestsScope extends ng.IScope {
        vm: ActivitiesInterests;
        dateOptions: any;
        endDateOptions: any;
    }

    interface IActivitiesInterests {
    }

    class ActivitiesInterests implements IActivitiesInterests {
        static controllerId: string = "activitiesInterests";
        static $inject: Array<string> = ["$location", "common", "Restangular", "$scope", "$uibModal", "$http", "$document", "config", "helper"];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        pdfButtonDisable: boolean;
        emailButtonDisable: boolean;
        show: string;
        isSaving: boolean;
        maxDate: Date;
        minDate: Date;
        opened: boolean;
        startOpen: boolean;
        endOpen: boolean;
        expList: any;
        actList: any;
        serviceList: any;
        healthList: any;
        awardList: any;
        leadList: any;
        networkList: any;
        projectList: any;

        editExpList: any;
        editActList: any;
        editServiceList: any;
        editHealthList: any;
        editAwardList: any;
        editLeadList: any;
        editNetworkList: any;
        editProjectList: any;
        projectSkills: any;
        projectSubjects: any;
        comments: any;

        constructor(private $location: ng.ILocationService,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $scope: IActivitiesInterestsScope,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private $http: any,
            private $document: ng.IDocumentService,
            private config: IConfig,
            private helper: IHelper) {

            this.log = common.logger.getLogFn(ActivitiesInterests.controllerId);
            this.logError = common.logger.getLogFn(ActivitiesInterests.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(ActivitiesInterests.controllerId, "success");
            this.opened = false;
            this.show = 'Experiences';
            this.maxDate = new Date();
            this.minDate = new Date(1899, 12);
            $scope.dateOptions = {
                showWeeks: false,
                maxDate: this.maxDate
            };
            $scope.endDateOptions = {
                showWeeks: false,
            };

            this.projectSubjects = [
                { id: "1", name: "Business" },
                { id: "2", name: "English Language Arts" },
                { id: "3", name: "Fine Art" },
                { id: "4", name: "Foreign Language" },
                { id: "5", name: "Math" },
                { id: "6", name: "Music" },
                { id: "7", name: "Physical Education" },
                { id: "8", name: "Science" },
                { id: "9", name: "Social Studies" },
                { id: "10", name: "Technical Specialty" }
            ]

            this.projectSkills = [
                { id: "1", name: "Active Learning" },
                { id: "2", name: "Active Listening" },
                { id: "3", name: "Complex Problem Solving" },
                { id: "4", name: "Coordination" },
                { id: "5", name: "Critical Thinking" },
                { id: "6", name: "Instructing" },
                { id: "7", name: "Learning Strategies" },
                { id: "8", name: "Mathematics" },
                { id: "9", name: "Monitoring" },
                { id: "10", name: "Negotiation" },
                { id: "11", name: "Operation Monitoring" },
                { id: "12", name: "Operations Analysis" },
                { id: "13", name: "Persuasion" },
                { id: "14", name: "Reading Comprehension" },
                { id: "15", name: "Science" },
                { id: "16", name: "Service Orientation" },
                { id: "17", name: "Speaking" },
                { id: "18", name: "Social Perceptiveness" },
                { id: "19", name: "Writing" },
            ]

            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, ActivitiesInterests.controllerId)
                .then(() => {
                    this.log("Activated Activities and Interests View");
                    this.getActivities();
                });
        }

        getActivities() {
            this.Restangular.one("ActivitiesInterests/getActivitiesInterests").get().then((results) => {
                this.comments = results;
                this.expList = results.experiences;
                this.actList = results.activities;
                this.serviceList = results.communityServices;
                this.healthList = results.healthActivities;
                this.awardList = results.awardsDistinctions;
                this.leadList = results.leadershipExperiences;
                this.networkList = results.networking;
                this.projectList = results.projects;

                this.editExpList = _.cloneDeep(results.experiences);
                this.editActList = _.cloneDeep(results.activities);
                this.editServiceList = _.cloneDeep(results.communityServices);
                this.editHealthList = _.cloneDeep(results.healthActivities);
                this.editAwardList = _.cloneDeep(results.awardsDistinctions);
                this.editLeadList = _.cloneDeep(results.leadershipExperiences);
                this.editNetworkList = _.cloneDeep(results.networking);
                this.editProjectList = _.cloneDeep(results.projects);
            }, (reason) => {
                console.error(reason);
            });
        }

        fixSingleDate(editItem: any) {
            if(editItem.date != null)
                editItem.date = moment(editItem.date).toDate();
        }

        fixMultiDate(editItem: any) {
            editItem.dateStart = moment(editItem.dateStart).toDate();
            if(editItem.dateEnd != null)
                editItem.dateEnd = moment(editItem.dateEnd).toDate();
        }

        checkDate(editItem: any) {
            console.log(moment(editItem.date).toDate());
        }

        saveExperience(experience: any) {
            this.Restangular.all("ActivitiesInterests/AddExperience").post(experience).then((results) => {
                experience.edit = false;
                experience.id = results;
                this.expList = _.cloneDeep(this.editExpList);
                this.logSuccess("Experience Saved.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveActivity(activity: any) {
            this.Restangular.all("ActivitiesInterests/AddActivity").post(activity).then((results) => {
                this.logSuccess("Activity Saved.", "", true);
                activity.id = results;
                activity.edit = false;
                this.actList = _.cloneDeep(this.editActList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveCommunityService(service: any) {
            this.Restangular.all("ActivitiesInterests/AddCommunityService").post(service).then((results) => {
                this.logSuccess("Community Service saved.", "", true);
                service.id = results;
                service.edit = false;
                this.serviceList = _.cloneDeep(this.editServiceList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        savePhysicalHealth(health: any) {
            this.Restangular.all("ActivitiesInterests/AddPhysicalHealth").post(health).then((results) => {
                this.logSuccess("Phyiscal Health saved.", "", true);
                health.id = results;
                health.edit = false;
                this.healthList = _.cloneDeep(this.editHealthList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveAward(award: any) {
            this.Restangular.all("ActivitiesInterests/AddAward").post(award).then((results) => {
                this.logSuccess("Award saved.", "", true);
                award.id = results;
                award.edit = false;
                this.awardList = _.cloneDeep(this.editAwardList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveLeadership(lead: any) {
            this.Restangular.all("ActivitiesInterests/AddLeadership").post(lead).then((results) => {
                this.logSuccess("Award saved.", "", true);
                lead.id = results;
                lead.edit = false;
                this.leadList = _.cloneDeep(this.editLeadList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveNetwork(network: any) {
            this.Restangular.all("ActivitiesInterests/AddNetwork").post(network).then((results) => {
                this.logSuccess("Award saved.", "", true);
                network.id = results;
                network.edit = false;
                this.networkList = _.cloneDeep(this.editNetworkList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        saveProject(project) {
            this.Restangular.all("ActivitiesInterests/AddProject").post(project).then((results) => {
                this.logSuccess("Award saved.", "", true);
                project.id = results;
                project.edit = false;
                this.projectList = _.cloneDeep(this.editProjectList);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        delete(id: any, section: any, editList: any, originalList: any, index: number) {
            var interest = { id: id, interestType: section };
            this.Restangular.all("ActivitiesInterests/DeleteInterest").post(interest).then((results) => {
                editList.splice(index, 1);
                originalList = _.cloneDeep(editList);
                this.logSuccess("Item Deleted.", "", true);
            }, (reason) => {
                console.error(reason);
                this.logError(reason, reason, true);
            });
        }

        newExp = (): void => {
            var startExp = { id: 0, expName: '', expType: '', expLocation: '', expDesc: '', expDate: null, edit: true };
            this.editExpList.unshift(startExp);
        };

        newActivity = (): void => {
            var startAct = { id: 0, actName: '', actType: '', actHoursWeek: null, actWeeksYear: null, actDesc: '', actDateStart: null, actDateEnd: null, actContinue: false, edit: true };
            this.editActList.unshift(startAct);
        };

        newService = (): void => {
            var startAct = { id: 0, name: '', type: '', hoursWeek: null, description: '', reflection: '', contact: '', dateStart: null, dateEnd: null, edit: true };
            this.editServiceList.unshift(startAct);
        };

        newHealth = (): void => {
            var startHealth = { id: 0, name: '', date: null, description: '', frequency: '', reflection: '', edit: true };
            this.editHealthList.unshift(startHealth);
        };

        newAward = (): void => {
            var startHealth = { id: 0, description: '', frequency: '', level: '', name: '', reflection: '', relation: '', Date: null, edit: true };
            this.editAwardList.unshift(startHealth);
        };

        newLead = (): void => {
            var startHealth = { id: 0, name: '', relation: '', level: '', dateStart: null, dateEnd: null, description: '', edit: true };
            this.editLeadList.unshift(startHealth);
        };

        newNetwork = (): void => {
            var startHealth = { id: 0, name: '', relation: '', email: '', description: '', edit: true };
            this.editNetworkList.unshift(startHealth);
        };

        newProject = (): void => {
            var startHealth = { id: 0, Name: '', Description: '', Advisors: '', Date: null, Tools: '', Skills: [], Subjects: [], edit: true }
            this.editProjectList.unshift(startHealth);
        };

        cancelEdit = (editArray: any, originalArray: any, itemToRemove: any, index: number): void => {
            if (itemToRemove.id != 0) {
                itemToRemove.edit = false;
                var original = originalArray[index];
                angular.copy(original, itemToRemove);
            } else {
                editArray.splice(index, 1);
            };
        };

        fixTestDate(editTest: any) {
            editTest.date = moment(editTest.date).toDate();
        }

        removeFromList(listObject: any, index: any) {
            listObject.splice(index, 1);
        }

        print = ($event) => {
            this.pdfButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html><head>" + headHtml + "</head><body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.helper.openFile(this.config.apiHost + "/pdf/download", { html: encodeURIComponent(html), url: location.origin }).then(() => {
                this.pdfButtonDisable = false;
            });

        };

        email = ($event) => {
            this.emailButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html>" + headHtml + "<body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.Restangular.all("pdf").all("email").post({ html: encodeURIComponent(html), url: location.origin })
                .then((response) => {
                    this.emailButtonDisable = false;
                    this.logSuccess("Email has been sent to the email address associated with your CFNC profile.", "Email has been sent to the email address associated with your CFNC profile.", true);
                }, (reason) => {
                    console.log(reason);
                    this.logError("There was a problem sending your email. Please try again later.", reason, true);
                }, (state) => {
                });
        }
    }

    angular.module("app").controller(ActivitiesInterests.controllerId, ActivitiesInterests);
}